import { AlertMessage } from "@hqy/react-shared-components";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import React, { Fragment } from "react";
import {
  AuthenticationError,
  AuthorizationError,
  EntityNotFoundError,
  ValidationError,
} from "../services/Errors";

const useStyles = makeStyles({
  main: {
    maxWidth: "340px",
    margin: "30px auto 0",
    // borderRadius: "3px",
    // textAlign: "left",
    // clear: "both"
  },
  title: { fontSize: "20px", fontWeight: 700, marginBottom: "10px" },
  description: {
    color: "#323232",
    fontSize: "16px",
    fontWeight: 400,
  },
  icon: { marginTop: "9px" },
});

function ErrorPage({ error }: { error: any }) {
  const classes = useStyles();

  let text = "";

  if (error.error && error.error === "login_required") {
    text = `Your previous session has timed out. Please log out and log back in as you do normally.`;
  } else if (error instanceof EntityNotFoundError) {
    text = `Entity not found.`;
    if (error.getRequestData()) {
      text = `${text}<br/> Request data: ${error.getRequestData()}`;
    }
  } else if (error instanceof ValidationError) {
    text = "Request validation error.";
    if (error.getRequestData()) {
      text = `${text}<br/>Reasons: ${error.getReasons()}; Request data: ${error.getRequestData()}`;
    }
  } else if (error instanceof AuthorizationError) {
    text = `You have insufficient permissions to view this information. <br/>Talk to your manager and refer to Scoop for instructions on how to request the proper access.`;
  } else if (error instanceof AuthenticationError) {
    text = `Unauthenticated.`;
  } else {
    text = `An error has occurred.`;
    if (error?.description) {
      text = `${text}<br/>${error.description}`;
    }
  }

  return (
    <Fragment>
      <Box className={classes.main}>
        <AlertMessage type={"error"} text={text} />
      </Box>
    </Fragment>
  );
}

export default ErrorPage;
